import Vue from 'vue'

// 平台的一些公共配置
const sysConfig = new Vue({
    data: {
        // 服务费比例，例如 0.03
        globalServiceCharge: 0,
        // 服务费比例百分号表示， 例如 3%
        globalServiceChargePercent: ''
    }
})

export default sysConfig


// WEBPACK FOOTER //
// ./src/common/sys-config.js